import { createSelector } from '@ngrx/store';
import { getFormsState } from '../store/store.selectors';
import { FormsStateInterface } from './forms.state';

export const getActiveFormToken = createSelector(
  getFormsState,
  (state: FormsStateInterface) => state.activeFormToken
);
